import axios from 'axios';
import { from } from 'rxjs';


class MediaService {
    uploadFile(file, mail) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('mail', mail);

        let promise = axios.post(`${globalConfig.api_URL}api/public/freedocumentvalidation`, formData, {
            objectResponse: true,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return from(promise);
    }

    // file or doclink, and the workspace (its exposed id); signing is signature-gateway's
    // process afterwards (the backend's eID path is gone)
    privateUploadFile(file, docLink, workSpaceId) {
        const formData = new FormData();
        file && formData.append('file', file);
        (docLink) && formData.append('doclink', docLink);
        formData.append('workspaceId', workSpaceId);

        let promise = axios.post(`${globalConfig.api_URL}api/private/validatedocument`, formData, {
            objectResponse: true,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return from(promise);
    }

    uploadFacsimileFile(file) {
        const formData = new FormData();
        formData.append('fileBase64', file);

        let promise = axios.post(`${globalConfig.api_URL}api/private/uploadfacsimile`, formData, {
            objectResponse: true,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return from(promise);
    }
}

export default new MediaService();